<template>
  <div>
    <common-header>
      <template #title>
        <p class="title">Creatives</p>
      </template>
    </common-header>
    <el-table
      :data="
        creatives.filter(
          (data) =>
            ((!folderId && (filter.advertiser || !data.folder)) ||
              data.folder === folderId) &&
            (!filter.advertiser || data.advertiser === filter.advertiser) &&
            (!filter.campaign || data.campaign === filter.campaign) &&
            (!search ||
              _.includes(data.name.toLowerCase(), search.toLowerCase()))
        )
      "
      row-key="_id"
      @selection-change="setSelections"
      @row-contextmenu="rowContextMenu"
      @row-dblclick="rowDblclick"
      style="font-size: 18px"
      empty-text="No creative! Let's create a new creative!"
      border
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        min-width="150"
        sortable
      ></el-table-column>
      <el-table-column prop="advertiser" label="Advertiser" width="150" sortable
        ><template slot-scope="{ row }">{{
          advertiserMapping[row.advertiser]
        }}</template></el-table-column
      >
      <el-table-column prop="campaign" label="Campaign" width="150" sortable
        ><template slot-scope="{ row }">{{
          campaignMapping[row.campaign]
        }}</template></el-table-column
      >
      <el-table-column prop="_type" label="Format" width="150" sortable>
        <template slot-scope="{ row }">{{ typeMapping[row._type] }}</template>
      </el-table-column>
      <el-table-column prop="created_at" label="Created" width="150" sortable>
        <template slot-scope="{ row }">
          <div class="cell">
            {{ moment(row.created_at).format("YYYY/MM/DD") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="right" width="300">
        <template slot="header" slot-scope="{ row }">
          <el-input v-model="search" placeholder="search" />
        </template>
        <template slot-scope="{ row }">
          <span v-for="item in operations.slice(0, 3)" :key="item.content">
            <el-button
              class="btn btn-outline-pink"
              v-if="
                item.canShow.includes(userInfo.service.user_level) &&
                  isSuitCreatorLevel(row, item)
              "
              @click="item.click(row)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.content"
                placement="bottom"
              >
                <i :class="item.icon"></i>
              </el-tooltip>
            </el-button>
          </span>
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-button class="btn btn-outline-pink">
                <i class="fas fa-ellipsis-v"></i>
              </el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div v-for="item in operations.slice(3)" :key="item.content">
                <el-dropdown-item
                  v-if="item.canShow.includes(userInfo.service.user_level)"
                  @click.native="item.click(row)"
                  :divided="item.divided"
                >
                  <i :class="item.icon"></i>
                  {{ item.content }}
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import MixFunc from "@/components/mixins/base";
export default {
  props: {
    filter: { type: Object, default: {} },
  },
  data() {
    return {
      folderId: this.$route.params.folderId,
      search: "",
      operations: [
        {
          type: "edit",
          content: "Edit",
          icon: "fas fa-pen",
          canShow: CONSTANT.USER_LEVEL_FILTER.MID,
          click: (row) =>
            this.showDialog({ type: CONSTANT.DIALOG_TYPE.CREATIVE, row }),
        },
        {
          type: "copyTag",
          content: "Copy tag",
          icon: "fas fa-clone",
          canShow: CONSTANT.USER_LEVEL_FILTER.ALL,
          click: (row) =>
            this.showDialog({
              type: CONSTANT.DIALOG_TYPE.CREATIVE_TEMPLATE,
              row,
            }),
        },
        {
          type: "preview",
          content: "Preview",
          icon: "fas fa-eye",
          canShow: CONSTANT.USER_LEVEL_FILTER.ALL,
          click: (row) => {
            if (row._type === "vast") {
              let url =
                "https://developers.google.com/interactive-media-ads/docs/sdks/html5/client-side/vastinspector";
              window.open(url, "_blank");
            } else {
              this.openBlankPage(`/preview/${row.creative_id}`);
            }
          },
        },
        {
          tpye: "sharePreviewLink",
          content: "Share preview link",
          icon: "fas fa-link",
          canShow: CONSTANT.USER_LEVEL_FILTER.ALL,
          click: (row) =>
            this.copy(
              "preview link",
              `${config.dashboard_domain}/preview/${row.creative_id}`
            ),
        },
        {
          type: "move",
          content: "Move to ...",
          icon: "fas fa-folder-open",
          canShow: CONSTANT.USER_LEVEL_FILTER.MID,
          click: (row) =>
            this.showDialog({
              type: CONSTANT.DIALOG_TYPE.SELECT_FOLDER,
              row: {
                id: row._id,
                folder: row.folder,
              },
            }),
        },
        {
          type: "dlete",
          content: "Delete",
          icon: "fas fa-trash-alt",
          canShow: CONSTANT.USER_LEVEL_FILTER.MID,
          click: (row) =>
            this.showDialog({
              type: CONSTANT.DIALOG_TYPE.DELETE,
              row: {
                item: CONSTANT.DIALOG_TYPE.CREATIVE,
                id: row._id,
                name: row.name,
              },
            }),
          divided: true,
        },
      ],
    };
  },
  components: {
    CommonHeader,
  },
  mixins: [MixFunc],
  computed: {
    ...mapState({
      typeMapping: (state) => state.creative.typeMapping,
      typeInfo: (state) => state.creative.typeInfo,
      creatives: (state) =>
        state.creative.creatives.map((res) => {
          let findType = state.creative.typeInfo.find(
            (type) => type.type === res._type
          );
          if (findType) {
            res.isSuitCreatorLevel = findType.isSuitCreatorLevel;
          } else {
            res.isSuitCreatorLevel = true;
          }
          return res;
        }),
      userInfo: (state) => state.user.userInfo,
      advertiserMapping: (state) =>
        state.advertiser.advertisers.reduce(
          (map, { _id, name }) => ({ ...map, [_id]: name }),
          {}
        ),
      campaignMapping: (state) =>
        _.flatMap(state.advertiser.advertisers, "campaigns").reduce(
          (map, { _id, name }) => ({ ...map, [_id]: name }),
          {}
        ),
    }),
  },
  methods: {
    ...mapMutations({
      setSelections: "creative/setSelections",
    }),
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
    }),
    rowContextMenu(row, col) {
      if (col.label) {
        this.showContextMenu({ type: CONSTANT.MENU_TYPE.CREATIVE_TABLE, row });
      }
    },
    rowDblclick(row) {
      this.showDialog({ type: CONSTANT.DIALOG_TYPE.CREATIVE, row });
    },
    isSuitCreatorLevel(creative, operation) {
      let check = ["edit", "copyTag"];
      if (check.includes(operation.type)) {
        return creative.isSuitCreatorLevel;
      }
      return true;
    },
  },
};
</script>

<style></style>
